import * as React from "react";
import {
  Stack,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  ListItem,
} from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";
import { LoadingButton, Loader } from "../../../shared";

export const SelectDataStreamDialog = ({
  state,
  onChangeDataStream,
  handleModal,
  handleUpdate,
}) => {
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const { dataStreams, isDataStreamLoading, isSaveButton, dataStreamInput } =
    state;
  const { create_new, data_stream_id, name } = dataStreamInput;

  const streamOptions = React.useMemo(
    () =>
      (dataStreams || []).map((stream) => ({
        value: stream.id,
        label: stream.name,
      })),
    [dataStreams]
  );

  const onSubmit = () => {
    if (validator.current.allValid()) {
      handleUpdate();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  if (isDataStreamLoading) {
    return <Loader />;
  }

  return (
    <Stack gap="16px" mt="16px">
      <RadioGroup
        value={create_new ? "new" : "existing"}
        onChange={(e) =>
          onChangeDataStream("create_new", e.target.value === "new")
        }
      >
        <FormControlLabel
          value="existing"
          control={<Radio />}
          label="Use an existing data stream"
          disabled={!streamOptions.length}
        />
        {!create_new && (
          <Stack sx={{ pl: "31px", pb: "8px" }}>
            {streamOptions.length ? (
              <InputControl
                type="dropdown"
                name="data_stream_id"
                label="Data Stream"
                options={streamOptions}
                value={
                  streamOptions.find(
                    (option) => option.value === data_stream_id
                  ) ?? null
                }
                onChange={(e, newValue) =>
                  onChangeDataStream("data_stream_id", newValue?.value ?? "")
                }
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                componentsProps={{
                  paper: {
                    sx: {
                      "& .MuiAutocomplete-listbox": { maxHeight: "260px" },
                    },
                  },
                }}
                renderOption={(props, option) => (
                  <ListItem
                    {...props}
                    key={option.value}
                    sx={{ wordBreak: "break-word" }}
                  >
                    {option.label}
                  </ListItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Data Stream"
                    placeholder="Search data stream"
                    error={!!validator.current.message(
                      "Data Stream",
                      data_stream_id,
                      "required"
                    )}
                    helperText={validator.current.message(
                      "Data Stream",
                      data_stream_id,
                      "required"
                    )}
                  />
                )}
              />
            ) : (
              <Typography variant="caption" color="#666666">
                No existing data streams found for this account. Please create a
                new one.
              </Typography>
            )}
          </Stack>
        )}

        <FormControlLabel
          value="new"
          control={<Radio />}
          label="Create a new data stream"
        />
        {create_new && (
          <Stack sx={{ pl: "31px" }}>
            <InputControl
              type="text"
              name="name"
              label="Data Stream Name"
              value={name || ""}
              onChange={(e) => onChangeDataStream("name", e.target.value)}
              required={true}
              error={validator.current.message(
                "Data Stream Name",
                name,
                "required"
              )}
              helperText={validator.current.message(
                "Data Stream Name",
                name,
                "required"
              )}
            />
          </Stack>
        )}
      </RadioGroup>

      <Stack
        sx={{
          flexDirection: "row",
          gap: "4px",
          alignItems: "center",
          padding: "6px 4px",
        }}
      >
        <img
          style={{ height: "18px" }}
          alt="details"
          src="/icons/ic_info.svg"
        />
        <Typography variant="caption" lineHeight="15px" color="#666666">
          Sales data for this store will be pushed to the selected data stream.
        </Typography>
      </Stack>

      <Stack direction="row" justifyContent="end" gap={2} mt="8px">
        <Button variant="text" onClick={() => handleModal("dataStream", false)}>
          Cancel
        </Button>
        <LoadingButton
          loading={isSaveButton}
          variant="contained"
          onClick={onSubmit}
        >
          Save
        </LoadingButton>
      </Stack>
    </Stack>
  );
};

export default SelectDataStreamDialog;
